import { render, staticRenderFns } from "./FactureClientDetails.vue?vue&type=template&id=77fed03f&"
import script from "./FactureClientDetails.vue?vue&type=script&lang=js&"
export * from "./FactureClientDetails.vue?vue&type=script&lang=js&"
import style0 from "./FactureClientDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports